module.exports = __webpack_public_path__ + "img/product-placeholder-8.d44320d.png";